import type { PatternProject, RunAssistMode } from '../types';

export interface ColorRun {
  orientation: Exclude<RunAssistMode, 'none'>;
  col: number;
  row: number;
  length: number;
}

export function findColorRuns(project: PatternProject, colorIndex: number, orientation: Exclude<RunAssistMode, 'none'>): ColorRun[] {
  const runs: ColorRun[] = [];
  const outer = orientation === 'horizontal' ? project.height : project.width;
  const inner = orientation === 'horizontal' ? project.width : project.height;
  for (let lane = 0; lane < outer; lane += 1) {
    let start = -1;
    for (let offset = 0; offset <= inner; offset += 1) {
      const col = orientation === 'horizontal' ? offset : lane;
      const row = orientation === 'horizontal' ? lane : offset;
      const cell = row * project.width + col;
      const matches = offset < inner && !project.empty[cell] && project.colorIndices[cell] === colorIndex;
      if (matches && start < 0) start = offset;
      if ((!matches || offset === inner) && start >= 0) {
        const length = offset - start;
        if (length >= 2) runs.push({ orientation, col: orientation === 'horizontal' ? start : lane, row: orientation === 'horizontal' ? lane : start, length });
        start = -1;
      }
    }
  }
  return runs;
}
